<template>
  <div class="page-container has-action">
    <van-nav-bar
      class="payment-navbar"
      fixed
      title="提现"
      left-arrow
      @click-left="goableBack()" />
    <div class="withdraw">
      <div class="block">
        <div class="fs-18">提现金额</div>
        <van-field
          class="mt-10"
          type="number"
          v-model="payForm.amount"
          @blur="setAmountInMin"
          :placeholder="withdrawTxt">
          <div slot="left-icon">￥</div>
        </van-field>
      </div>
      <div class="block">
        <van-field
          v-model="bankCard"
          readonly
          clearable
          input-align="right"
          label="银行卡"
          placeholder="请选择银行卡"
          @click="bankPicker.show = true"
          right-icon="arrow-down" />
        <van-field
          :value="userInfo.phone"
          label="手机号"
          input-align="right"
          disabled />
        <van-field
          v-model="payForm.wcode"
          type="number"
          maxlength="6"
          clearable
          placeholder="请输入6位验证码">
          <van-button
            :loading="smsForm.loading"
            loading-text="发送中..."
            @click="sendSms"
            plain
            :disabled="isSendSMSEnable"
            slot="button"
            size="small"
            type="danger"
            >{{ getSendBtnText }}</van-button
          >
        </van-field>
      </div>
    </div>
    <div class="page-action">
      <van-button
        class="payment-next-step"
        @click="onClickNext"
        type="danger"
        size="large"
        >确定</van-button
      >
    </div>
    <van-popup v-model="bankPicker.show" position="bottom">
      <van-picker
        show-toolbar
        value-key="tailTag"
        :columns="bankPicker.columns"
        :loading="bankPicker.loading"
        @cancel="bankPicker.show = false"
        @confirm="confirmBankPicker" />
    </van-popup>
  </div>
</template>

<script>
import * as PayApi from "@/api/pay"
import * as CustApi from "@/api/cust"
import {
  NavBar,
  Button,
  Radio,
  Toast,
  Field,
  Checkbox,
  Popup,
  Picker,
  Icon
} from "vant"
import { mapGetters, mapActions } from "vuex"

export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Icon.name]: Icon
  },

  data() {
    return {
      bankCard: "",
      withdrawTxt: "提现金额 1 元起",
      //  用户选择银行卡
      bankPicker: {
        show: false,
        loading: false,
        columns: []
      },
      payForm: {
        vcode: "",
        amount: "",
        bindCardId: "", // 用户选择的银行卡的银行id
        terminal: "H5"
      },
      smsForm: {
        loading: false,
        smsCountDown: 0,
        smsInterval: null
      }
    }
  },
  computed: {
    isSendSMSEnable() {
      return this.smsForm.smsCountDown !== 0
    },
    getSendBtnText() {
      if (this.smsForm.smsCountDown > 0) {
        return this.smsForm.smsCountDown
      } else {
        return "获取验证码"
      }
    },
    ...mapGetters(["userInfo"])
  },

  methods: {
    // 失去焦点，如果金额小于最小起购金额。自动填充最小金额
    setAmountInMin() {
      if (this.payForm.amount.length < 1) {
        Toast("请输入提现金额")
        return
      }

      if (this.payForm.amount.toString().indexOf(".") > 0) {
        Toast("提现金额必须是整数")
        this.payForm.amount = Math.ceil(this.payForm.amount)
        return
      }
    },

    getBankList() {
      this._showLoading()
      this.bankPicker.loading = true
      CustApi.listBindCard()
        .then((data) => {
          this._dismissLoading()
          if (!data || !data.length) {
            return
          }

          this.bankPicker.columns = data
          this.bankPicker.loading = false
          this.bankCard = data[0].tailTag
          this.payForm.bindCardId = data[0].id
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },

    // 提现
    onClickNext() {
      if (!this.payForm.amount) {
        Toast("请输入充值金额!")
        return
      }

      if (!this.payForm.bindCardId) {
        Toast("请先选择银行卡!")
        return
      }

      PayApi.fundoutclaimer(this.payForm)
        .then((data) => {
          this._dismissLoading()
          if (!data) {
            Toast("服务器繁忙, 请稍后再试")
            return
          }
          this.$router.push({
            path: "/withdraw/succ",
            query: {
              amount: this.payForm.amount
            }
          })
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },

    // 确认选择银行卡
    confirmBankPicker(value) {
      this.bankCard = value.tailTag
      this.payForm.bindCardId = value.id
      this.bankPicker.show = false
    },
    sendSms() {
      this.smsForm.loading = true
      CustApi.withdrawcode()
        .then((data) => {
          this.smsForm.loading = false
          this.startSMSTimer()
        })
        .catch((e) => {
          this.smsForm.loading = false
          Toast(e.msg || e.message)
        })
    },
    startSMSTimer() {
      this.smsForm.smsCountDown = 60
      this.smsForm.smsInterval = setInterval(() => {
        this.smsForm.smsCountDown--
        if (this.smsForm.smsCountDown <= 0) {
          clearInterval(this.smsForm.smsInterval)
        }
      }, 1000)
    },
    ...mapActions(["getUserInfo"])
  },
  beforeMount() {
    if (!this.userInfo) {
      this._showLoading()
      this.getUserInfo()
        .then(() => {
          this._dismissLoading()
        })
        .catch((e) => {
          this._dismissLoading()
          if (e) {
          }
        })
    }
    this.getBankList()
  }
}
</script>

<style lang="less" scoped>
.payment_1 {
  .bank_name {
    line-height: 1;
    font-size: 12px;
    text-align: right;
  }
  .bank_quota {
    color: rgb(159, 173, 174);
    font-size: 10px;
    width: 140px;
    display: inline-block;
    line-height: 1;
    margin-top: 4px;
    margin-right: -10px;
  }
}
</style>
